import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class BusyService {
	busyRequestCount = 0;
	timer: any;
	constructor(private spinnerService: NgxSpinnerService) {}

	busy(autoDismiss = true) {
		this.busyRequestCount++;
		clearTimeout(this.timer);
		if(autoDismiss) {
			this.timer = setTimeout(() => {
				if (this.busyRequestCount > 0) {
					this.busyRequestCount = 0;
					this.spinnerService.hide();
				}
			}, 5000);

		}
		this.spinnerService.show(undefined, {
			type: 'line-scale-party',
			bdColor: 'rgba(192,192,192,0.3)',
			color: '#333333',
		});
	}

	idle(delay = 0) {
		if (this.busyRequestCount >= 0) {
			this.busyRequestCount--;

		}

		clearTimeout(this.timer);
		
		if (this.busyRequestCount <= 0) {
			this.busyRequestCount = 0;
			if(delay == 0) {
				this.spinnerService.hide();
				
			} else {
				setTimeout(() => {
					this.spinnerService.hide();
				}, delay);

			}

		}

	}

}
